import { api, REQUEST_TYPE } from 'store/api'
import { ModuleTags } from './consts'
import { getGrinScanForScanTagging, grinScanFields } from 'graphql/scanTagging.graphql'

export const ScanTagging = api.injectEndpoints({
  endpoints: build => ({
    fetchGrinScanForScanTagging: build.query({
      query: ({ grinScanId }) => ({
        query: getGrinScanForScanTagging(grinScanFields),
        queryName: 'getGrinScan',
        type: REQUEST_TYPE.GRAPHQL,
        variables: {
          id: grinScanId
        }
      }),
      transformResponse: response => response.getGrinScan,
      providesTags: [ModuleTags.ScanTagging]
    }),
    getNextMessage: build.query({
      query: ({ patientId, scanId, hiDoctorId }) => ({
        type: REQUEST_TYPE.GET,
        path: `/copilot/v1/hi/nextMessage`,
        queryParams: {
          patientId,
          scanId,
          hiDoctorId
        }
      }),
      providesTags: [ModuleTags.ScanTagging]
    })
  })
})

export const { useFetchGrinScanForScanTaggingQuery, useGetNextMessageQuery } = ScanTagging
